import React, { useState } from 'react';
import Banner from '../components/common/Banner';

const ContactUsPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: '',
    category: 'general'
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission here
    console.log('Form submitted:', formData);
    // You can add form submission logic here
    alert('Thank you for your message! We will get back to you soon.');
  };

  return (
    <div className="h-full w-full fade-in">
      <Banner 
        title="Contact Us"
        subtitle="Get in Touch | We're Here to Help | Connect with FIT"
        imageSrc="https://images.unsplash.com/photo-1423666639041-f56000c27a9a?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80"
      />
      
      <div className="max-w-6xl mx-auto p-4 sm:p-6 md:p-10 space-y-8 sm:space-y-12">
        
        {/* Contact Information Cards */}
        <section>
          <div className="mb-8">
            <h2 className="text-2xl sm:text-3xl font-serif font-bold text-slate mb-3 sm:mb-4">Get in Touch</h2>
            <p className="text-gray-500">Reach out to us through any of the following channels or fill out the contact form below.</p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
            {/* Main Office */}
            <div className="bg-white p-6 rounded-xl border border-border_gray text-center">
              <div className="w-16 h-16 bg-crimson rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="fas fa-map-marker-alt text-white text-2xl"></i>
              </div>
              <h3 className="font-bold text-slate mb-3">Main Office</h3>
              <p className="text-sm text-gray-600 leading-relaxed">
                FiT Engineering College<br/>
                123 Engineering Street<br/>
                Tech City, State - 123456<br/>
                India
              </p>
            </div>

            {/* Phone Numbers */}
            <div className="bg-white p-6 rounded-xl border border-border_gray text-center">
              <div className="w-16 h-16 bg-gold rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="fas fa-phone text-white text-2xl"></i>
              </div>
              <h3 className="font-bold text-slate mb-3">Phone Numbers</h3>
              <div className="text-sm text-gray-600 space-y-1">
                <p><strong>Main:</strong> +91 98765-43210</p>
                <p><strong>Admission:</strong> +91 98765-43211</p>
                <p><strong>Academic:</strong> +91 98765-43212</p>
                <p><strong>Placement:</strong> +91 98765-43213</p>
              </div>
            </div>

            {/* Email Addresses */}
            <div className="bg-white p-6 rounded-xl border border-border_gray text-center">
              <div className="w-16 h-16 bg-slate rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="fas fa-envelope text-white text-2xl"></i>
              </div>
              <h3 className="font-bold text-slate mb-3">Email Addresses</h3>
              <div className="text-sm text-gray-600 space-y-1">
                <p><strong>General:</strong> info@fit.ac.in</p>
                <p><strong>Admission:</strong> admissions@fit.ac.in</p>
                <p><strong>Academic:</strong> academics@fit.ac.in</p>
                <p><strong>Placement:</strong> placements@fit.ac.in</p>
              </div>
            </div>
          </div>
        </section>

        {/* Contact Form */}
        <section>
          <div className="grid lg:grid-cols-2 gap-12">
            {/* Contact Form */}
            <div className="bg-white p-8 rounded-xl border border-border_gray">
              <h3 className="text-xl font-bold text-crimson mb-6">Send us a Message</h3>
              
              <form onSubmit={handleSubmit} className="space-y-6">
                <div className="grid md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-2">Full Name *</label>
                    <input 
                      type="text" 
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:border-crimson outline-none"
                      placeholder="Enter your full name"
                      required
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-2">Email Address *</label>
                    <input 
                      type="email" 
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:border-crimson outline-none"
                      placeholder="Enter email address"
                      required
                    />
                  </div>
                </div>
                
                <div className="grid md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-2">Phone Number</label>
                    <input 
                      type="tel" 
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:border-crimson outline-none"
                      placeholder="Enter phone number"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-2">Inquiry Category</label>
                    <select 
                      name="category"
                      value={formData.category}
                      onChange={handleChange}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:border-crimson outline-none"
                    >
                      <option value="general">General Inquiry</option>
                      <option value="admission">Admission</option>
                      <option value="academic">Academic</option>
                      <option value="placement">Training & Placement</option>
                      <option value="research">Research & Development</option>
                      <option value="infrastructure">Infrastructure</option>
                      <option value="feedback">Feedback</option>
                    </select>
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">Subject *</label>
                  <input 
                    type="text" 
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:border-crimson outline-none"
                    placeholder="Brief subject of your inquiry"
                    required
                  />
                </div>

                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">Message *</label>
                  <textarea 
                    rows="5"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:border-crimson outline-none"
                    placeholder="Please describe your inquiry in detail..."
                    required
                  ></textarea>
                </div>

                <div className="flex gap-4">
                  <button 
                    type="submit"
                    className="bg-crimson hover:bg-red-800 text-white font-bold py-3 px-8 rounded-lg transition flex items-center gap-2"
                  >
                    <i className="fas fa-paper-plane"></i>
                    Send Message
                  </button>
                  <button 
                    type="reset"
                    onClick={() => setFormData({
                      name: '',
                      email: '',
                      phone: '',
                      subject: '',
                      message: '',
                      category: 'general'
                    })}
                    className="bg-gray-200 hover:bg-gray-300 text-gray-700 font-bold py-3 px-8 rounded-lg transition"
                  >
                    Reset Form
                  </button>
                </div>
              </form>
            </div>

            {/* Quick Contact & Office Hours */}
            <div className="space-y-6">
              {/* Office Hours */}
              <div className="bg-blue-50 border border-blue-200 rounded-xl p-6">
                <h3 className="text-lg font-bold text-blue-800 mb-4 flex items-center">
                  <i className="fas fa-clock text-blue-600 mr-2"></i>
                  Office Hours
                </h3>
                <div className="space-y-3 text-sm">
                  <div className="flex justify-between">
                    <span className="text-blue-700 font-semibold">Monday - Friday:</span>
                    <span className="text-blue-600">9:00 AM - 6:00 PM</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-blue-700 font-semibold">Saturday:</span>
                    <span className="text-blue-600">9:00 AM - 2:00 PM</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-blue-700 font-semibold">Sunday:</span>
                    <span className="text-blue-600">Closed</span>
                  </div>
                  <div className="border-t border-blue-200 pt-3 mt-4">
                    <p className="text-blue-700 text-xs">
                      <strong>Note:</strong> Emergency contact available 24/7 for current students through student portal.
                    </p>
                  </div>
                </div>
              </div>

              {/* Quick Links */}
              <div className="bg-white p-6 rounded-xl border border-border_gray">
                <h3 className="text-lg font-bold text-slate mb-4">Quick Actions</h3>
                <div className="space-y-3">
                  <button className="w-full bg-crimson hover:bg-red-800 text-white font-bold py-3 px-4 rounded-lg transition text-sm">
                    <i className="fas fa-calendar-alt mr-2"></i>
                    Schedule a Campus Visit
                  </button>
                  <button className="w-full bg-gold hover:bg-yellow-600 text-white font-bold py-3 px-4 rounded-lg transition text-sm">
                    <i className="fas fa-download mr-2"></i>
                    Download Admission Brochure
                  </button>
                  <button className="w-full bg-slate hover:bg-gray-800 text-white font-bold py-3 px-4 rounded-lg transition text-sm">
                    <i className="fas fa-map mr-2"></i>
                    Get Directions to Campus
                  </button>
                </div>
              </div>

              {/* Social Media */}
              <div className="bg-white p-6 rounded-xl border border-border_gray">
                <h3 className="text-lg font-bold text-slate mb-4">Follow Us</h3>
                <div className="flex gap-3">
                  <a href="#" className="w-10 h-10 rounded-full bg-blue-600 flex items-center justify-center text-white hover:bg-blue-700 transition">
                    <i className="fab fa-facebook-f"></i>
                  </a>
                  <a href="#" className="w-10 h-10 rounded-full bg-sky-500 flex items-center justify-center text-white hover:bg-sky-600 transition">
                    <i className="fab fa-twitter"></i>
                  </a>
                  <a href="#" className="w-10 h-10 rounded-full bg-blue-700 flex items-center justify-center text-white hover:bg-blue-800 transition">
                    <i className="fab fa-linkedin-in"></i>
                  </a>
                  <a href="#" className="w-10 h-10 rounded-full bg-pink-500 flex items-center justify-center text-white hover:bg-pink-600 transition">
                    <i className="fab fa-instagram"></i>
                  </a>
                  <a href="#" className="w-10 h-10 rounded-full bg-red-600 flex items-center justify-center text-white hover:bg-red-700 transition">
                    <i className="fab fa-youtube"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Map Section - Placeholder */}
        <section>
          <div className="bg-white p-6 rounded-xl border border-border_gray">
            <h3 className="text-xl font-bold text-slate mb-4">Find Us on Map</h3>
            <div className="bg-gray-100 rounded-lg aspect-[16/9] flex items-center justify-center">
              <div className="text-center">
                <i className="fas fa-map text-6xl text-gray-400 mb-4"></i>
                <p className="text-gray-500 font-semibold">Interactive Map</p>
                <p className="text-gray-400 text-sm">Campus location and directions</p>
              </div>
            </div>
          </div>
        </section>

      </div>
    </div>
  );
};

export default ContactUsPage;